var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  top: 0px;\n  z-index: 10000000;\n  justify-content: space-between;\n  @media (max-width: 768px) {\n      padding: 0px;\n  }\n  h3 {\n    margin: 0px;\n    text-align: right;\n    color: #fff;\n    transition: color 0.25s ease-in-out;\n  }\n  &.white {\n    background-color: rgba(255,255,255,0.98);\n    border-bottom: 1px solid #E6E8ED;\n    h3 {\n      color: inherit;\n    }\n  }\n  &.transparent {\n    background-color: rgba(255,255,255,0);\n    border-bottom: 1px solid transparent;\n  }\n'], ['\n  position: fixed;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  padding: 16px;\n  align-items: center;\n  top: 0px;\n  z-index: 10000000;\n  justify-content: space-between;\n  @media (max-width: 768px) {\n      padding: 0px;\n  }\n  h3 {\n    margin: 0px;\n    text-align: right;\n    color: #fff;\n    transition: color 0.25s ease-in-out;\n  }\n  &.white {\n    background-color: rgba(255,255,255,0.98);\n    border-bottom: 1px solid #E6E8ED;\n    h3 {\n      color: inherit;\n    }\n  }\n  &.transparent {\n    background-color: rgba(255,255,255,0);\n    border-bottom: 1px solid transparent;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 80px;\n  width: 120px;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  transition: all 0.4s ease-in-out;\n  will-change: opacity;\n  opacity: ', ';\n  pointer-events: none;\n'], ['\n  height: 80px;\n  width: 120px;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  transition: all 0.4s ease-in-out;\n  will-change: opacity;\n  opacity: ', ';\n  pointer-events: none;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  height: 80px;\n  width: 120px;\n'], ['\n  height: 80px;\n  width: 120px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import useWindowScrollPosition from '@rehooks/window-scroll-position';
import Logo from '../Logo';
var Container = styled.header(_templateObject);
var ContainerWhite = styled.div(_templateObject2, function (props) {
  return props.opacity;
});
var ContainerBlue = styled.div(_templateObject2, function (props) {
  return props.opacity;
});
var LogoWrapper = styled.div(_templateObject3);

var Header2 = function Header2(props) {
  var position = useWindowScrollPosition({
    throttle: 0
  });
  var top = position.y < 20 ? true : false;
  var whiteOpacity = top ? 1 : 0;
  var blueOpacity = !top ? 1 : 0;
  var containerClass = top ? 'transparent' : 'white';
  return React.createElement(Container, {
    className: containerClass
  }, React.createElement(LogoWrapper, null, React.createElement(ContainerBlue, {
    opacity: blueOpacity
  }, React.createElement(Logo, {
    width: '120px'
  })), React.createElement(ContainerWhite, {
    opacity: whiteOpacity
  }, React.createElement(Logo, {
    white: true,
    width: '120px'
  }))), React.createElement('h3', null, props.children));
};

export default Header2;